var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import Actionable from "../Actionable/index.js";
import Bubble from "../Bubble/index.js";
import Icon from "../Icon/index.js";
import Stack from "../Stack/index.js";
import Text from "../Text/index.js";
import { useTabContext } from "./Tab.context.js";
import styles from "@bookingcom/bui-core/css/Tab.module.css";
var TabTriggerPrivate = function (props) {
    var id = props.id, text = props.text, title = props.title, icon = props.icon, bubble = props.bubble, href = props.href, linkAttributes = props.linkAttributes, native = props.native, handleKeys = props.handleKeys, triggerIndex = props.triggerIndex, isOverflow = props.isOverflow, isMobile = props.isMobile, getItemStyle = props.getItemStyle;
    var _a = useTabContext(), activeTabId = _a.activeTabId, changeTab = _a.changeTab, getButtonRef = _a.getButtonRef, vertical = _a.vertical, variant = _a.variant;
    var isLinkBehavior = !!href;
    var isSelected = activeTabId === id;
    var isRowBehaviour = !vertical || variant === "rounded";
    var itemClassName = classNames(styles.item, isOverflow && !isMobile && styles["item--hidden"], isSelected && styles["item--selected"]);
    return (React.createElement("li", { key: id, className: itemClassName, style: getItemStyle() },
        React.createElement(Actionable, { onClick: function () { return changeTab(id, triggerIndex); }, preventDefault: !native, href: href, className: styles.link, insetFocus: true, ref: function (el) { return getButtonRef(el, triggerIndex); }, attributes: __assign(__assign({}, linkAttributes), { role: isLinkBehavior ? undefined : "tab", "aria-current": isLinkBehavior && isSelected ? "page" : undefined, "aria-selected": isLinkBehavior ? undefined : isSelected, "aria-controls": (href && !href.startsWith('#')) ? undefined : id, onKeyUp: handleKeys, tabIndex: isSelected || native ? 0 : -1 }) },
            React.createElement(Stack, { tagName: "span", direction: isRowBehaviour ? "row" : "column", alignItems: "center", gap: isRowBehaviour ? 2 : 1, wrap: "nowrap" },
                icon && React.createElement(Icon, { className: styles.icon, svg: icon, size: "medium" }),
                title && !icon && React.createElement("span", { className: styles.title }, title),
                React.createElement(Stack.Item, { shrink: true },
                    React.createElement(Text, { tagName: "span" },
                        text,
                        bubble && React.createElement(Bubble, __assign({ className: styles.bubble }, bubble))))))));
};
export default TabTriggerPrivate;
